import { use } from "react";

import { OfferActionsContext } from "@/react/components/Paywalls/CheckoutWithSession/pages/OfferPage/OfferActionsContext";

export const InlineOfferActions = () => {
  const context = use(OfferActionsContext);
  if (!context) {
    throw new Error("InlineOfferActions requires OfferActionsLayout");
  }

  return (
    <div
      ref={context.setInlineActions}
      className="w-full"
      aria-hidden={context.isSticky}
      inert={context.isSticky}
      data-testid="offer-inline-actions"
    >
      {context.actions}
    </div>
  );
};
